export default __webpack_public_path__ + "static/favicon-a9f41533fea13fc01d6df2fa9f194cde.png";